const GOOGLE_API_KEY = "AIzaSyBugY30io6Y6OYl5VdkFRSWKX2LKw-IM0w";
const GOOGLE_DRIVE_FOLDER_ID = "1FEEoFoaGsy5-gPATfAUyYOHNJ2jFoRSn";

export const sheetIdToUrl = (id) =>
  `https://holy-sheet.visualise.today/sheet/${id}`;

export const googleDriveFolderUrl = `https://www.googleapis.com/drive/v3/files?q='${GOOGLE_DRIVE_FOLDER_ID}'+in+parents&key=${GOOGLE_API_KEY}`;



// WEBPACK FOOTER //
// ./src/modules/google.js